import { cn } from '@/lib/utils';
import { formatCurrency, formatSignedCurrency } from './financialImpact';

type ImpactTone = 'success' | 'danger' | 'warning' | 'neutral';

export function ImpactRow({
  label,
  value,
  tone,
  prominent,
  total,
  placeholder,
  isPercent,
}: {
  label: string;
  value: number;
  tone?: ImpactTone;
  prominent?: boolean;
  total?: boolean;
  placeholder?: string;
  isPercent?: boolean;
}) {
  const computedTone = tone ?? (value > 0 ? 'success' : value < 0 ? 'danger' : 'neutral');
  const displayValue = placeholder
    ? placeholder
    : isPercent
      ? `${value.toFixed(1)}%`
      : value === 0 && !total
        ? '-'
        : total
          ? formatCurrency(value)
          : formatSignedCurrency(value);

  return (
    <div className="flex items-baseline justify-between gap-4">
      <span
        className={cn(
          'font-medium text-muted-foreground',
          (prominent || total) && 'text-foreground',
        )}
      >
        {label}
      </span>
      <span
        className={cn(
          'font-semibold tabular-nums text-foreground',
          computedTone === 'success' && value !== 0 && !placeholder && 'text-emerald-700',
          computedTone === 'danger' && value !== 0 && !placeholder && 'text-destructive',
          computedTone === 'warning' && value !== 0 && !placeholder && 'text-amber-700',
          placeholder && 'text-muted-foreground',
          prominent && 'text-base',
          total && 'text-base',
        )}
      >
        {displayValue}
      </span>
    </div>
  );
}
